<template>
  <div class="mm-row-block">
    <el-form label-width="120px" label-position="left">
      <div class="form-isheader-group">
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人賬號" required>
                <el-input :disabled="readonly" v-model="form.account_num_format" @input="cardformat()" @change="cardformat" ref="cardInput" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人名稱" required>
                <el-input :disabled="readonly" v-model="form.account_name" clearable>
                  <el-button slot="append" @click="form.account_name=sify(form.account_name)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人電話">
                <el-input :disabled="readonly" v-model="form.phone" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <!-- <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="身份證或護照" prop="card">
                <el-input :disabled="readonly" v-model="form.id_card"></el-input>
              </el-form-item>
            </div>
          </div> -->

          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="銀行名稱" required>
                <cnbankselect :form="form"></cnbankselect>
              </el-form-item>
              <el-form-item>
                <el-input :disabled="readonly" v-model="form.cnbankname" clearable>
                  <el-button slot="append" @click="form.cnbankname=sify(form.cnbankname)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="分行名稱">
                <div class="mb15">
                  <subbranchselect :form="form" :reset="reset"></subbranchselect>
                </div>
                <el-input :disabled="readonly" v-model="form.branch_name" clearable>
                  <el-button slot="append" @click="form.branch_name=sify(form.branch_name)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="收款人地址">
                <el-input :disabled="readonly" v-model="form.address" clearable>
                  <el-button slot="append" @click="form.address=sify(form.address)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="銀行備註">
                <el-input :disabled="readonly" v-model="form.remark">
                  <el-button slot="append" @click="form.remark=sify(form.remark)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

    </el-form>
  </div>

</template>

<script>
import BankCardInfo from 'bankcardinfo';
import cnbankselect from './CNBankSelect.vue';
import subbranchselect from './SubBranchSelect.vue';
export default {
  components: {
    cnbankselect,
    subbranchselect,
  },
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    reset: {
      type: Boolean,
      default: true,
    }
  },
  name: "bankinfo",
  data () {
    return {
      bankListBF: [],
      form: {
        address: "", // 地址
        phone: "", // 電話
        id_card: "", // 身份証
        account_num_format: "",
        account_num: "",// 賬號
        account_name: "", // 持卡人
        province_id: "", // 省份
        city_id: "", // 城市
        country_id: 0,
        countryname: '',
        branch_id: "", // 支行名稱
        branch_name: "", // 支行名稱自定義
        hkbank_id: 0,
        cnbank_id: 0,
        bankname: "",
        cnbankname:"",
        currency_id: "", // 貨幣id
        swift_code: "", // swift_code
        address: "", // 收款人地址
        remark: "", // 銀行備註
      }

    }
  },
  methods: {
    cardformat () {
      let val = this.form.account_num_format;
      this.formatCardNumber(this.form, val);
    },
    getbankinfo () {
      let val = this.form.account_num;
      if (val.length >= 13) {
        var _this = this;
        BankCardInfo.getBankBin(val)
          .then(function (data) {
            if (data.bankName) {
              _this.post('/api/bank/getbank_by_bankcode', data).then(response => {
                _this.form.bankname = response.name;
                _this.form.cnbank_id = response.id;
              }).catch(error => {
                _this.form.bankname = '';
                _this.form.cnbank_id = 0;
              });
            }
          })
          .catch(function (err) {
            _this.form.bankname = '';
            _this.form.cnbank_id = 0;
          })
      } else {
        this.form.bankname = '';
        this.form.cnbank_id = 0;
      }
    },
    // 獲取銀行列表
    getBanksList () {
      this.post('/api/bank/banks', { page: 1, size: 1000, condition: '' })
        .then(response => {
          // console.log(response);
          this.bankListBF = response;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  created () {
    this.getBanksList();
    // 过滤表格配置传递的参数，如果存在则替换默认值，否则按默认值显示
    for (let key in this.data) {
      if (this.form.hasOwnProperty(key)) { //把默认配置中的配置项进行替换
        this.form[key] = this.data[key];
      }
    }

    this.form.cnbankname = this.form.bankname;

  },
  watch: {
    'form.account_num_format' (val) {
      if (val) {
        this.form.account_num = this.mytrim(val);
      } else {
        this.form.account_num = '';
      }
    },
    'form.account_num' (val) {
      if (val.length >= 13) {
        var _this = this;
        BankCardInfo.getBankBin(val)
          .then(function (data) {
            if (data.bankName) {
              // if (data.bankName == '深发/平安银行') {
              //   data.bankName = '平安银行';
              // }

              console.log(data);
              let hasname = false;
              _this.bankListBF.some(item => {
                if (item.name == data.bankName) {
                  _this.form.cnbank_id = item.id + '';
                  _this.form.bankinfo = _this.form.bankname = item.name;
                  hasname = true;
                  return true;
                }
              })

              if (!hasname) {
                _this.post('/api/bank/fullbankname', { bankname: data.bankName }).then(response => {
                  if (response.status == 'success') {
                    let bankdata = response.data;
                    _this.bankListBF.some(item => {
                      if (item.id == bankdata.id) {
                        _this.form.cnbank_id = item.id + '';
                        _this.form.bankinfo = _this.form.bankname = item.name;
                        return true;
                      }
                    })
                  }
                }).catch(error => { });
              }

            }
          })
          .catch(function (err) {
            console.log(err);
            _this.form.bankinfo = _this.form.bankname = '';
          })
      }
    },
    form: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.$emit('update:data', newVal);
      }
    }
  }
}
</script>

<style scoped>
.flex50 {
  flex: 0 50%;
}
.flex-start {
  justify-content: start;
}
.mb15 {
  margin-bottom: 15px;
}
</style>
